import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum AttemptStatus {
  Generated = 1,
  InProgress = 2,
  Executed = 3,
  Failed = 4,
}
EnumDescriptions.setDescriptions(AttemptStatus, [
  i18n.t('enums.generated'),
  i18n.t('enums.in_progress'),
  i18n.t('enums.executed'),
  i18n.t('enums.canceled'),
]);
